import React, { useState, useEffect, useRef } from "react";
import config from "../config";
import orca from "../Images/ORCA.png";
import UserMessenger from "./UserMessenger";

const UserDashboard = ({ setIsLoggedIn, setCurrentPage }) => {
    const [userData, setUserData] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [profilePicture, setProfilePicture] = useState(null);
    const [currentView, setCurrentView] = useState("dashboard");
    const [isDarkMode, setIsDarkMode] = useState(true);
    const messengerRef = useRef(null);

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
    };
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        setUserData(user);

        if (user) {
            loadProfilePicture(user.username);
        }
    }, []);
    // Add this to the beginning of UserDashboard component, after existing useEffect

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        setUserData(user);

        if (user) {
            // Check if user has Google profile picture in localStorage
            if (user.googleProfilePicture) {
                console.log("✅ Using Google profile picture from localStorage");
                setProfilePicture(user.googleProfilePicture);
            } else {
                // Try to load from backend
                loadProfilePicture(user.username);
            }
        }
    }, []);

    const loadProfilePicture = async (username) => {
        try {
            const response = await fetch(
                `${config.API_BASE_URL}/Users/get-profile-picture/${username}`
            );
            if (response.ok) {
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setProfilePicture(url);

                // Update localStorage with backend profile picture
                const user = JSON.parse(localStorage.getItem("user"));
                user.localProfilePicture = url;
                localStorage.setItem("user", JSON.stringify(user));
            } else {
                console.log("No profile picture found in backend");
            }
        } catch (error) {
            console.error("Error loading profile picture:", error);
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        setIsLoggedIn(false);
        setCurrentPage("home");
    };

    if (!userData) {
        return (
            <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'} flex items-center justify-center`}>
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent"></div>
            </div>
        );
    }

    return (

        <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'} transition-colors duration-300`}>
            {/* Dark Mode Toggle Button - Floating */}
            <div className="fixed top-4 right-4 z-50 group">
                <button
                    onClick={toggleDarkMode}
                    className={`p-3 rounded-full shadow-lg transition-all duration-300 transform hover:scale-110 ${isDarkMode
                        ? 'bg-gray-800 text-yellow-400 hover:bg-gray-700'
                        : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    aria-label="Toggle dark mode"
                >
                    {isDarkMode ? (
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" />
                        </svg>
                    ) : (
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                        </svg>
                    )}
                </button>
                <div className={`absolute right-full mr-3 top-1/2 -translate-y-1/2 px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-gray-900 text-white'
                    } text-sm`}>
                    {isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                </div>
            </div>
            <header className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-b sticky top-0 z-40 shadow-sm transition-colors duration-300`}>
                <div className="container mx-auto px-4 py-3">
                    <div className="flex items-center justify-between">
                        {/* Logo */}
                        <div className="flex items-center gap-4">
                            <div
                                className={`
      px-4 py-2 rounded-lg transition-colors duration-300
      ${isDarkMode ? "bg-white" : "bg-gray-white"}
    `}
                            >
                                <img
                                    src={orca}
                                    alt="ORCA Helpdesk Logo"
                                    className="h-10 w-auto object-contain"
                                />
                            </div>


                            <div>
                                <span className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'} text-sm`}>User Portal</span>
                                <p className={`${isDarkMode ? 'text-white' : 'text-gray-900'} font-semibold`}>Support Desk</p>
                            </div>
                        </div>

                        {/* Profile Menu */}
                        <div className="relative">
                            <button
                                onClick={() => setIsMenuOpen(!isMenuOpen)}
                                className={`flex items-center gap-3 px-4 py-2 ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-100 hover:bg-gray-200'} rounded-lg transition-all`}
                            >
                                <div className="text-right hidden md:block">
                                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Welcome back</p>
                                    <p className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{userData.fullNames}</p>
                                </div>
                                <div className="relative">
                                    {profilePicture ? (
                                        <img
                                            src={profilePicture}
                                            alt="Profile"
                                            className="w-10 h-10 rounded-full object-cover border-2 border-blue-500"
                                        />
                                    ) : (
                                        <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center text-white font-bold">
                                            {userData.fullNames.charAt(0).toUpperCase()}
                                        </div>
                                    )}
                                    <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
                                </div>
                                <svg
                                    className={`w-5 h-5 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'} transition-transform ${isMenuOpen ? "rotate-180" : ""}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>

                            {/* Dropdown Menu */}
                            {isMenuOpen && (
                                <div className={`absolute right-0 mt-2 w-64 ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-xl shadow-lg overflow-hidden`}>
                                    <div className="p-4 bg-gradient-to-r from-blue-500 to-blue-600">
                                        <div className="flex items-center gap-3">
                                            {profilePicture ? (
                                                <img
                                                    src={profilePicture}
                                                    alt="Profile"
                                                    className="w-12 h-12 rounded-full object-cover border-2 border-white"
                                                />
                                            ) : (
                                                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-white font-bold text-xl">
                                                    {userData.fullNames.charAt(0).toUpperCase()}
                                                </div>
                                            )}
                                            <div>
                                                <p className="font-semibold text-white">{userData.fullNames}</p>
                                                <p className="text-xs text-white/80">{userData.email}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="py-2">
                                        <button
                                            onClick={() => {
                                                setCurrentView("profile");
                                                setIsMenuOpen(false);
                                            }}
                                            className={`w-full px-4 py-3 text-left ${isDarkMode ? 'hover:bg-gray-700 text-gray-300 hover:text-white' : 'hover:bg-gray-50 text-gray-700 hover:text-gray-900'} transition flex items-center gap-3`}
                                        >

                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            <span className="font-medium">My Profile</span>
                                        </button>

                                        <button
                                            onClick={() => {
                                                setCurrentView("settings");
                                                setIsMenuOpen(false);
                                            }}
                                            className={`w-full px-4 py-3 text-left ${isDarkMode ? 'hover:bg-gray-700 text-gray-300 hover:text-white' : 'hover:bg-gray-50 text-gray-700 hover:text-gray-900'} transition flex items-center gap-3`}
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            <span className="font-medium">Settings</span>
                                        </button>

                                        <div className={`border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'} my-2`}></div>
                                        <button
                                            onClick={() => {
                                                setIsMenuOpen(false);
                                                handleLogout();
                                            }}
                                            className={`w-full px-4 py-3 text-left transition flex items-center gap-3 text-red-600 hover:text-red-700 ${isDarkMode ? 'hover:bg-red-900/20' : 'hover:bg-red-50'}`}
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                            </svg>
                                            <span className="font-medium">Logout</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <div className="container mx-auto px-4 py-8">
                {currentView === "dashboard" && <DashboardView userData={userData} setCurrentView={setCurrentView} isDarkMode={isDarkMode} onOpenMessenger={() => messengerRef.current?.openExpanded()} />}
                {currentView === "create-ticket" && <CreateTicketView userData={userData} setCurrentView={setCurrentView} isDarkMode={isDarkMode} />}
                {currentView === "my-tickets" && <MyTicketsView userData={userData} setCurrentView={setCurrentView} isDarkMode={isDarkMode} />}
                {currentView === "profile" && (
                    <ProfileView
                        userData={userData}
                        profilePicture={profilePicture}
                        loadProfilePicture={loadProfilePicture}
                        setCurrentView={setCurrentView}
                        isDarkMode={isDarkMode}
                    />
                )}

                {currentView === "settings" && <SettingsView userData={userData} setCurrentView={setCurrentView} isDarkMode={isDarkMode} />}
            </div>
            <UserMessenger ref={messengerRef} userData={userData} isDarkMode={isDarkMode} />

        </div>

    );
};

// Dashboard View Component
const DashboardView = ({ userData, setCurrentView, isDarkMode, onOpenMessenger }) => (

    <>
        {/* Welcome Section */}
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl p-8 shadow-lg mb-8">
            <h1 className="text-4xl font-bold text-white mb-2">
                Welcome back, {userData.fullNames}! 👋
            </h1>
            <p className="text-white/90 text-lg">
                Submit and track your support tickets here
            </p>
        </div>

        {/* Quick Actions */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
            <QuickActionCard
                onClick={() => setCurrentView("create-ticket")}
                icon={
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                }
                title="Create Ticket"
                description="Submit a new support request"
                isDarkMode={isDarkMode}
            />
            <QuickActionCard
                onClick={() => setCurrentView("my-tickets")}
                icon={
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                }
                title="My Tickets"
                description="View your submitted tickets"
                isDarkMode={isDarkMode}
            />
            <QuickActionCard
                onClick={() => setCurrentView("profile")}
                icon={
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                }
                title="Profile"
                description="Update your information"
                isDarkMode={isDarkMode}
            />
            <QuickActionCard
                onClick={() => onOpenMessenger()}
                icon={
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
                    </svg>
                }
                title="Messages"
                description="Chat with support"
                isDarkMode={isDarkMode}
            />
        </div >

        {/* User Info Card */}
        < div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-2xl p-8 shadow-sm mb-8 transition-colors duration-300`}>
            <h2 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-6`}>Your Information</h2>
            <div className="grid md:grid-cols-2 gap-6">
                <InfoItem label="Full Name" value={userData.fullNames} isDarkMode={isDarkMode} />
                <InfoItem label="Email" value={userData.email} isDarkMode={isDarkMode} />
                <InfoItem label="Username" value={userData.username} isDarkMode={isDarkMode} />
                <InfoItem label="Phone" value={userData.phone || "Not provided"} isDarkMode={isDarkMode} />
                <InfoItem label="Address" value={userData.address || "Not provided"} isDarkMode={isDarkMode} />
                <InfoItem
                    label="Language"
                    value={userData.language === "en" ? "English" : userData.language}
                    isDarkMode={isDarkMode}
                />
                <InfoItem
                    label="Registration Date"
                    value={new Date(userData.registrationDate).toLocaleDateString()}
                    isDarkMode={isDarkMode}
                />
                <InfoItem label="User ID" value={userData.identificationCode} isDarkMode={isDarkMode} />

            </div>
        </div >

        {/* Recent Activity Placeholder */}
        < div
            className={`
    border rounded-2xl p-8 shadow-sm transition-colors duration-300
    ${isDarkMode
                    ? "bg-gray-800 border-gray-700"
                    : "bg-white border-gray-200"}
  `}
        >
            <h2
                className={`
      text-2xl font-bold mb-6
      ${isDarkMode ? "text-white" : "text-gray-900"}
    `}
            >
                Recent Tickets
            </h2>

            <div className="text-center py-12">
                <svg
                    className={`
        w-16 h-16 mx-auto mb-4
        ${isDarkMode ? "text-gray-500" : "text-gray-300"}
      `}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                    />
                </svg>

                <p
                    className={`
        text-lg font-medium
        ${isDarkMode ? "text-gray-300" : "text-gray-600"}
      `}
                >
                    No tickets yet
                </p>

                <p
                    className={`
        mt-2
        ${isDarkMode ? "text-gray-400" : "text-gray-500"}
      `}
                >
                    Create your first ticket to get started
                </p>

                <button
                    onClick={() => setCurrentView("create-ticket")}
                    className={`
        mt-6 px-6 py-3 rounded-lg font-medium transition
        ${isDarkMode
                            ? "bg-blue-600 hover:bg-blue-500 text-white"
                            : "bg-blue-500 hover:bg-blue-600 text-white"}
      `}
                >
                    Create First Ticket
                </button>
            </div>
        </div >


    </>
);

// Create Ticket View Component
const CreateTicketView = ({ userData, setCurrentView, isDarkMode }) => {
    const [loading, setLoading] = useState(false);
    const [attachment, setAttachment] = useState(null);



    const [requestTypes, setRequestTypes] = useState([]);
    useEffect(() => {
        const fetchRequestTypes = async () => {
            try {
                const res = await fetch(`${config.API_BASE_URL}/RequestType`);
                if (!res.ok) throw new Error("Failed to fetch request types");
                const data = await res.json();
                setRequestTypes(data);
            } catch (err) {
                console.error("RequestType fetch error:", err);
            }
        };

        fetchRequestTypes();
    }, []);

    const [form, setForm] = useState({
        Subject: "",
        Name: userData.fullNames,
        Contact: userData.phone || "",
        Email: userData.email,
        Category: "",
        Description: "",
        Priority: "Low",
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const generateTicketNumber = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

        return `TICKET-${year}${month}${day}-${hours}${minutes}${seconds}-${milliseconds}`;
    };

    // ✅ FIXED handleSubmit — i-replace mo yung existing handleSubmit sa CreateTicketView

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.Subject || !form.Email || !form.Category || !form.Description || !form.Priority) {
            alert("Please fill in all required fields!");
            return;
        }

        setLoading(true);
        try {
            const fd = new FormData();
            const ticketNumber = generateTicketNumber();

            fd.append("TicketNumber", ticketNumber);
            fd.append("Subject", form.Subject);
            fd.append("Name", form.Name);
            fd.append("Contact", form.Contact || "N/A");
            fd.append("Email", form.Email);
            fd.append("Category", form.Category);
            fd.append("Description", form.Description);
            fd.append("Priority", form.Priority);
            fd.append("UserId", userData.username);
            fd.append("Status", "Open");
            fd.append("Notes", "Created via User Portal");
            fd.append("Subtask", "None");
            fd.append("Followup", "false");
            fd.append("Done", "false");
            fd.append("Team", "General Support");
            fd.append("Origin", "User Portal");
            fd.append("Tags", "user-submission");
            fd.append("InternalNotes", `Submitted by ${userData.fullNames}`);
            fd.append("DescriptionNotes", "User ticket");
            fd.append("ActivityDescription", `Ticket created at ${new Date().toLocaleString()}`);

            const now = new Date().toISOString();
            fd.append("CreatedAt", now);
            fd.append("Timestamp", now);
            fd.append("DateStarted", now);
            fd.append("DateUpdated", now);

            const defaultDeadline = new Date();
            defaultDeadline.setDate(defaultDeadline.getDate() + 7);
            fd.append("Deadline", defaultDeadline.toISOString());

            fd.append("TimeSpent", "0");
            fd.append("TimeRemaining", "0");
            fd.append("TimeGoal", "48 hours");
            fd.append("Calendar", "Standard Hours");
            fd.append("JQL", `priority = ${form.Priority}`);
            fd.append("Condition", "New");
            fd.append("OpenIncidents", "0");
            fd.append("MyIncidents", "0");
            fd.append("MajorIncidents", "0");
            fd.append("Components", "General");
            fd.append("Summary", form.Subject);
            fd.append("Reporter", userData.fullNames);
            fd.append("Estimate", "TBD");
            fd.append("Linked", "None");
            fd.append("Severity", "Sev-3");
            fd.append("Urgency", "Medium");
            fd.append("IssueType", "General Request");
            fd.append("Affected", "N/A");
            fd.append("Assignees", "Unassigned");
            fd.append("WorkDescription", "Pending review");
            fd.append("OpenDescription", `Opened on ${new Date().toLocaleDateString()}`);
            fd.append("PendingDescription", "");
            fd.append("CompleteDescription", "");
            fd.append("ResolvedDescription", "");
            fd.append("CloseDescription", "");
            fd.append("Reason", "New submission");

            if (attachment) {
                fd.append("attachment", attachment);
            }

            // ── 1. CREATE TICKET ──────────────────────────────────────────────────
            const res = await fetch(`${config.API_BASE_URL}/Tickets`, {
                method: "POST",
                body: fd,
            });

            if (!res.ok) {
                throw new Error("Failed to create ticket");
            }

            // ── 2. SEND CONFIRMATION EMAIL ────────────────────────────────────────
            let emailSent = false;
            try {
                const emailRes = await fetch(`${config.API_BASE_URL}/Email/send`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        toEmail: form.Email,
                        toName: form.Name,
                        subject: `[Ticket Received] ${ticketNumber} – Your request is being processed`,
                        body:
                            `Hi ${form.Name},\n\n` +
                            `Thank you for reaching out! We have successfully received your support ticket and our team will review it shortly.\n\n` +
                            `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n` +
                            `📋 TICKET DETAILS\n` +
                            `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n` +
                            `Ticket Number  : ${ticketNumber}\n` +
                            `Request Type   : ${form.Subject}\n` +
                            `Category       : ${form.Category}\n` +
                            `Priority       : ${form.Priority}\n` +
                            `Status         : Open\n` +
                            `Date Submitted : ${new Date().toLocaleString()}\n\n` +
                            `📝 YOUR DESCRIPTION\n` +
                            `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n` +
                            `${form.Description}\n\n` +
                            `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n` +
                            `⏳ WHAT HAPPENS NEXT?\n` +
                            `Our support team will review your ticket and respond as soon as possible.\n` +
                            `You can track your ticket status anytime by logging in to the User Portal.\n\n` +
                            `If you have additional information to add, please reply to this email or update your ticket in the portal.\n\n` +
                            `Best regards,\n` +
                            `Orca Helpdesk Team 🐋\n` +
                            `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n` +
                            `This is an automated message. Please do not reply directly to this email.`,
                    }),
                });

                if (emailRes.ok) {
                    emailSent = true;
                    console.log("✅ Confirmation email sent to", form.Email);
                } else {
                    console.warn("⚠️ Email API returned error:", emailRes.status);
                }
            } catch (emailErr) {
                // Email failure should NOT block the ticket creation success flow
                console.warn("⚠️ Ticket created but email failed:", emailErr.message);
            }

            // ── 3. SHOW SUCCESS ───────────────────────────────────────────────────
            alert(
                `✅ Ticket Created Successfully!\n\n` +
                `Ticket Number: ${ticketNumber}\n\n` +
                (emailSent
                    ? `📧 A confirmation email has been sent to ${form.Email}.`
                    : `⚠️ Ticket created but we couldn't send the confirmation email.`)
            );

            setCurrentView("my-tickets");

        } catch (err) {
            console.error("Error:", err);
            alert(`❌ Error: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-3xl mx-auto">
            <button
                onClick={() => setCurrentView("dashboard")}
                className={`mb-6 flex items-center gap-2 ${isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition`}
            >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Back to Dashboard
            </button>

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-2xl p-8 shadow-sm transition-colors duration-300`}>
                <h2 className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-2`}>Create New Ticket</h2>
                <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mb-8`}>Fill out the form below to submit your support request</p>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Subject */}
                    <div>
                        <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                            Request Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="Subject"
                            value={form.Subject}
                            onChange={handleChange}
                            className={`w-full px-4 py-3 border ${isDarkMode
                                ? 'bg-gray-700 border-gray-600 text-white'
                                : 'bg-white border-gray-300'
                                } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                            required
                        >
                            <option value="">Select request type...</option>

                            {requestTypes.map((rt) => (
                                <option key={rt.id} value={rt.requestTypeName}>
                                    {rt.requestTypeName}
                                </option>
                            ))}
                        </select>


                    </div>

                    {/* Name */}
                    <div>
                        <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                            Name
                        </label>
                        <input
                            type="text"
                            name="Name"
                            value={form.Name}
                            onChange={handleChange}
                            className={`w-full px-4 py-3 border ${isDarkMode ? 'bg-gray-900 border-gray-600 text-gray-400' : 'bg-gray-50 border-gray-300'} rounded-lg`}
                            readOnly
                        />
                    </div>

                    {/* Contact and Email */}
                    <div className="grid md:grid-cols-2 gap-6">
                        <div>
                            <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                                Contact Number
                            </label>
                            <input
                                type="tel"
                                name="Contact"
                                value={form.Contact}
                                onChange={handleChange}
                                className={`w-full px-4 py-3 border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                                placeholder="09XXXXXXXXX"
                            />
                        </div>

                        <div>
                            <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                                Email Address <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                name="Email"
                                value={form.Email}
                                onChange={handleChange}
                                className={`w-full px-4 py-3 border ${isDarkMode ? 'bg-gray-900 border-gray-600 text-gray-400' : 'bg-gray-50 border-gray-300'} rounded-lg`}
                                readOnly
                                required
                            />
                        </div>
                    </div>

                    {/* Category and Priority */}
                    <div className="grid md:grid-cols-2 gap-6">
                        <div>
                            <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                                Ticket Category <span className="text-red-500">*</span>
                            </label>
                            <select
                                name="Category"
                                value={form.Category}
                                onChange={handleChange}
                                className={`w-full px-4 py-3 border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                                required
                            >
                                <option value="">Select category...</option>
                                <option value="General - IT Support">General - IT Support</option>
                                <option value="Network">Network</option>
                                <option value="Software">Software</option>
                                <option value="Hardware">Hardware</option>
                            </select>
                        </div>

                        <div>
                            <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                                Priority <span className="text-red-500">*</span>
                            </label>
                            <select
                                name="Priority"
                                value={form.Priority}
                                onChange={handleChange}
                                className={`w-full px-4 py-3 border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition`}
                                required
                            >
                                <option value="Low">Low</option>
                                <option value="Medium">Medium</option>
                                <option value="High">High</option>
                            </select>
                        </div>
                    </div>

                    {/* Description */}
                    <div>
                        <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                            Ticket Description <span className="text-red-500">*</span>
                        </label>
                        <textarea
                            name="Description"
                            value={form.Description}
                            onChange={handleChange}
                            rows={6}
                            className={`w-full px-4 py-3 border ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' : 'bg-white border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-none`}
                            placeholder="Please describe your issue in detail..."
                            required
                        />
                    </div>

                    {/* Attachment */}
                    <div>
                        <label className={`block text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} mb-2`}>
                            Attachment
                        </label>
                        <div className={`border-2 border-dashed ${isDarkMode ? 'border-gray-600 hover:border-blue-500' : 'border-gray-300 hover:border-blue-400'} rounded-lg p-6 text-center transition`}>
                            <input
                                type="file"
                                id="file-upload"
                                onChange={(e) => setAttachment(e.target.files[0])}
                                className="hidden"
                            />
                            <label htmlFor="file-upload" className="cursor-pointer">
                                {!attachment ? (
                                    <>
                                        <svg className={`w-12 h-12 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'} mx-auto mb-3`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                        </svg>
                                        <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'} font-medium mb-1`}>Drop files here or click to browse</p>
                                        <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>PNG, JPG, PDF, DOC up to 10MB</p>
                                    </>
                                ) : (
                                    <div className="flex items-center justify-center gap-2">
                                        <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                        <span className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'} font-medium`}>{attachment.name}</span>
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setAttachment(null);
                                            }}
                                            className="text-red-500 hover:text-red-700"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}
                            </label>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="flex gap-4 pt-4">
                        <button
                            type="button"
                            onClick={() => setCurrentView("dashboard")}
                            className={`flex-1 px-6 py-3 ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600 text-gray-200' : 'bg-gray-200 hover:bg-gray-300 text-gray-700'} rounded-lg font-semibold transition`}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="flex-1 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        >
                            {loading ? (
                                <>
                                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                                    Creating...
                                </>
                            ) : (
                                <>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Submit Ticket
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};



// ─── MyTickets View ────────────────────────────────────────────────────────────
const MyTicketsView = ({ userData, setCurrentView, isDarkMode }) => {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [sortBy, setSortBy] = useState("newest");
    const [filterStatus, setFilterStatus] = useState("All");
    const [search, setSearch] = useState("");

    useEffect(() => {
        fetch(`${config.API_BASE_URL}/Tickets`)
            .then((res) => res.json())
            .then((data) => {
                const myTickets = data.filter((t) => t.email === userData.email);
                setTickets(myTickets);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [userData.email]);

    const sortTickets = (list, method) => {
        const sorted = [...list];
        const priorityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
        const statusOrder = { Open: 4, "In Progress": 3, Pending: 2, Resolved: 1, Closed: 0 };
        switch (method) {
            case "newest": return sorted.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
            case "oldest": return sorted.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));
            case "priority": return sorted.sort((a, b) => (priorityOrder[b.priority] || 0) - (priorityOrder[a.priority] || 0));
            case "status": return sorted.sort((a, b) => (statusOrder[b.status] || 0) - (statusOrder[a.status] || 0));
            default: return sorted;
        }
    };

    const filteredTickets = sortTickets(
        tickets.filter((t) => {
            const matchSearch =
                t.ticketNumber?.toLowerCase().includes(search.toLowerCase()) ||
                t.subject?.toLowerCase().includes(search.toLowerCase());
            const matchStatus = filterStatus === "All" || t.status === filterStatus;
            return matchSearch && matchStatus;
        }),
        sortBy
    );

    const getStatusStyle = (status) => ({
        Open: "bg-blue-500/20 text-blue-400 border border-blue-500/40",
        Pending: "bg-yellow-500/20 text-yellow-400 border border-yellow-500/40",
        "In Progress": "bg-blue-600/30 text-blue-300 border border-blue-400/40",
        Resolved: "bg-green-500/20 text-green-400 border border-green-500/40",
        Closed: "bg-gray-500/20 text-gray-400 border border-gray-500/40",
    }[status] || "bg-slate-500/20 text-slate-400 border border-slate-500/40");

    const getPriorityStyle = (priority) => ({
        Low: "bg-green-500/20 text-green-400 border border-green-500/40",
        Medium: "bg-yellow-500/20 text-yellow-400 border border-yellow-500/40",
        High: "bg-orange-500/20 text-orange-400 border border-orange-500/40",
        Critical: "bg-red-500/20 text-red-400 border border-red-500/40",
    }[priority] || "bg-slate-500/20 text-slate-400");

    const formatDate = (d) => d ? new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "numeric", day: "numeric" }) : "N/A";
    const formatDateTime = (d) => d ? new Date(d).toLocaleDateString("en-US", { month: "numeric", day: "numeric", year: "numeric" }) : "";

    const card = isDarkMode ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200";
    const text = isDarkMode ? "text-white" : "text-gray-900";
    const sub = isDarkMode ? "text-gray-400" : "text-gray-500";
    const inputBg = isDarkMode ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400" : "bg-white border-gray-300 text-gray-900 placeholder-gray-400";

    const stats = [
        { label: "Total", value: tickets.length, color: "text-blue-400", bg: "bg-blue-500/10 border-blue-500/20" },
        { label: "Open", value: tickets.filter((t) => t.status === "Open").length, color: "text-cyan-400", bg: "bg-cyan-500/10 border-cyan-500/20" },
        { label: "In Progress", value: tickets.filter((t) => t.status === "In Progress").length, color: "text-yellow-400", bg: "bg-yellow-500/10 border-yellow-500/20" },
        { label: "Resolved", value: tickets.filter((t) => t.status === "Resolved").length, color: "text-green-400", bg: "bg-green-500/10 border-green-500/20" },
    ];

    return (
        <div className="min-h-screen">
            {/* Top Bar */}
            <div className="flex items-center justify-between mb-6">
                <button
                    onClick={() => setCurrentView("dashboard")}
                    className={`flex items-center gap-2 px-4 py-2.5 rounded-xl border transition-all ${isDarkMode ? "bg-gray-800 border-gray-700 text-gray-300 hover:text-white hover:bg-gray-700" : "bg-white border-gray-200 text-gray-600 hover:text-gray-900 hover:bg-gray-50"} shadow-sm`}
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    <span className="font-medium text-sm">Back</span>
                </button>
                <button
                    onClick={() => setCurrentView("create-ticket")}
                    className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold text-sm transition-all shadow-lg"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    New Ticket
                </button>
            </div>

            {/* Header */}
            <div className="mb-6">
                <h2 className={`text-3xl font-bold ${text}`}>My Tickets</h2>
                <p className={`${sub} mt-1 text-sm`}>View and track all your support requests</p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
                {stats.map((s) => (
                    <div key={s.label} className={`${card} border rounded-2xl p-4 ${s.bg} transition-colors`}>
                        <p className={`text-xs font-medium ${sub} mb-1`}>{s.label}</p>
                        <p className={`text-2xl font-bold ${s.color}`}>{s.value}</p>
                    </div>
                ))}
            </div>

            {/* Filters */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
                <div className="relative md:col-span-1">
                    <svg className={`absolute left-3.5 top-3 w-4 h-4 ${sub}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input className={`w-full pl-10 pr-4 py-2.5 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 text-sm ${inputBg}`} placeholder="Search tickets..." value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
                <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} className={`px-4 py-2.5 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 text-sm ${inputBg}`}>
                    <option value="All">All Status</option>
                    <option value="Open">Open</option>
                    <option value="Pending">Pending</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Resolved">Resolved</option>
                    <option value="Closed">Closed</option>
                </select>
                <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className={`px-4 py-2.5 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 text-sm ${inputBg}`}>
                    <option value="newest">Newest First</option>
                    <option value="oldest">Oldest First</option>
                    <option value="priority">By Priority</option>
                    <option value="status">By Status</option>
                </select>
            </div>

            {/* Loading */}
            {loading && (
                <div className="text-center py-16">
                    <div className="inline-block animate-spin rounded-full h-10 w-10 border-2 border-blue-500 border-t-transparent mb-4"></div>
                    <p className={`${sub} text-sm`}>Loading your tickets...</p>
                </div>
            )}

            {/* Empty */}
            {!loading && filteredTickets.length === 0 && (
                <div className={`${card} border rounded-2xl text-center py-20`}>
                    <div className={`inline-flex items-center justify-center w-20 h-20 rounded-2xl ${isDarkMode ? "bg-gray-700" : "bg-gray-100"} mb-5`}>
                        <svg className={`w-10 h-10 ${sub}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>
                    <h3 className={`text-xl font-bold ${text} mb-2`}>{search || filterStatus !== "All" ? "No tickets found" : "No tickets yet"}</h3>
                    <p className={`${sub} text-sm mb-6 max-w-xs mx-auto`}>{search || filterStatus !== "All" ? "Try adjusting your search or filter." : "Submit your first support request."}</p>
                    {!search && filterStatus === "All" && (
                        <button onClick={() => setCurrentView("create-ticket")} className="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold text-sm transition-all shadow-lg">
                            Create First Ticket
                        </button>
                    )}
                </div>
            )}

            {/* Ticket Cards Grid */}
            {!loading && filteredTickets.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    {filteredTickets.map((ticket) => (
                        <div
                            key={ticket.ticketNumber}
                            onClick={() => setSelectedTicket(ticket)}
                            className={`${card} border rounded-2xl p-5 cursor-pointer transition-all hover:shadow-lg hover:border-blue-500/40 hover:-translate-y-0.5 group`}
                        >
                            <div className="flex items-start justify-between mb-3">
                                <div className="flex-1 min-w-0">
                                    <p className={`font-mono text-xs ${sub} mb-1`}>{ticket.ticketNumber}</p>
                                    <h3 className={`font-semibold ${text} truncate group-hover:text-blue-400 transition-colors`}>{ticket.subject || "Untitled"}</h3>
                                </div>
                                <svg className={`w-4 h-4 ${sub} ml-2 shrink-0 group-hover:text-blue-400 transition-colors`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </div>
                            <p className={`text-sm ${sub} line-clamp-2 mb-4`}>{ticket.description || "No description"}</p>
                            <div className="flex items-center gap-2 flex-wrap mb-4">
                                <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${getStatusStyle(ticket.status)}`}>{ticket.status || "N/A"}</span>
                                <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${getPriorityStyle(ticket.priority)}`}>{ticket.priority || "N/A"}</span>
                                {ticket.category && <span className={`px-2.5 py-1 rounded-full text-xs ${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-600"}`}>{ticket.category}</span>}
                            </div>
                            <div className={`flex items-center justify-between pt-3 border-t ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
                                <span className={`text-xs ${sub}`}>📅 {formatDate(ticket.createdAt)}</span>
                                {ticket.assignees && ticket.assignees !== "Unassigned" && ticket.assignees !== "" && (
                                    <span className={`text-xs ${sub}`}>👤 {ticket.assignees}</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {!loading && filteredTickets.length > 0 && (
                <p className={`text-center text-xs ${sub} mt-4`}>Showing {filteredTickets.length} of {tickets.length} tickets</p>
            )}

            {/* Ticket Detail Modal */}
            {selectedTicket && (
                <TicketDetailModal
                    ticket={selectedTicket}
                    onClose={() => setSelectedTicket(null)}
                    getStatusStyle={getStatusStyle}
                    getPriorityStyle={getPriorityStyle}
                    formatDate={formatDate}
                    formatDateTime={formatDateTime}
                />
            )}
        </div>
    );
};

// ─── Ticket Detail Modal ───────────────────────────────────────────────────────
// ─── TicketDetailModal (User Side) ────────────────────────────────────────────
// Features: View activities, post comments, react with emoji (Like/Love/Laugh/Dislike)
// Drop-in replacement for the existing TicketDetailModal in UserDashboard.jsx


const REACTIONS = {
    "👍": "Like",
    "❤️": "Love",
    "😂": "Laugh",
    "👎": "Dislike",
};

const REACTION_COLORS = {
    Like: "text-blue-400",
    Love: "text-red-400",
    Laugh: "text-yellow-400",
    Dislike: "text-slate-400",
};

const API = config.API_BASE_URL;

// ─── TicketDetailModal ─────────────────────────────────────────────────────────
const TicketDetailModal = ({ ticket, onClose, getStatusStyle, getPriorityStyle, formatDate, formatDateTime }) => {
    const [activities, setActivities] = useState([]);
    const [loadingActivities, setLoadingActivities] = useState(true);
    const [commentText, setCommentText] = useState("");
    const [postingComment, setPostingComment] = useState(false);
    const [replyingTo, setReplyingTo] = useState(null); // { activityId, commentId, userName }
    const [replyText, setReplyText] = useState("");
    const [postingReply, setPostingReply] = useState(false);
    const feedBottomRef = useRef(null);
    const [currentUserPic, setCurrentUserPic] = useState(null);
    const [assigneePic, setAssigneePic] = useState(null);

    useEffect(() => {
        if (!ticket.assignees || ticket.assignees === "Unassigned") return;

        const fetchAssigneePic = async () => {
            try {
                // 1. Kuhanin lahat ng admins
                const res = await fetch(`${API}/Admin`);
                if (!res.ok) return;
                const admins = await res.json();

                // 2. Hanapin yung admin na may matching fullNames
                const match = admins.find(a =>
                    a.fullNames === ticket.assignees ||
                    a.username === ticket.assignees
                );

                if (!match) return;

                // 3. Fetch profile pic gamit yung username
                const picRes = await fetch(`${API}/Admin/get-profile-picture/${match.username}`);
                if (!picRes.ok) return;

                const blob = await picRes.blob();
                setAssigneePic(URL.createObjectURL(blob));
            } catch { /* silent fail */ }
        };

        fetchAssigneePic();
    }, [ticket.assignees]);
    // PALITAN YUNG currentUser — simple lang, user lang dito
    const currentUser = (() => {
        try {
            const u = JSON.parse(localStorage.getItem("user") || "{}");
            return { userId: u.username || "user", userName: u.fullNames || u.username || "User" };
        } catch { return { userId: "user", userName: "User" }; }
    })();

    const steps = ["Submitted", "In Review", "Resolved"];
    const stepIndex = { Open: 0, Pending: 0, "In Progress": 1, Resolved: 2, Closed: 2 }[ticket.status] ?? 0;
    const progressPct = stepIndex === 0 ? 10 : stepIndex === 1 ? 55 : 100;

    const initials = (name) =>
        name ? name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2) : "?";


    // PALITAN YUNG useEffect na fetch ng profile pic
    useEffect(() => {
        const fetchCurrentUserPic = async () => {
            try {
                const res = await fetch(
                    `${API}/Users/get-profile-picture/${currentUser.userId}` // Users, hindi Admin
                );
                if (res.ok) {
                    const blob = await res.blob();
                    setCurrentUserPic(URL.createObjectURL(blob));
                }
            } catch { /* silent fail */ }
        };
        fetchCurrentUserPic();
    }, [currentUser.userId]);
    // ─── Fetch Activities ──────────────────────────────────────────────────────
    const fetchActivities = async () => {
        try {
            const res = await fetch(
                `${API}/Activities/ticket/${encodeURIComponent(ticket.ticketNumber)}?userId=${currentUser.userId}`
            );
            if (!res.ok) throw new Error();
            setActivities(await res.json());
        } catch {
            setActivities([]);
        } finally {
            setLoadingActivities(false);
        }
    };

    useEffect(() => { fetchActivities(); }, [ticket.ticketNumber]);

    // Auto-scroll to bottom when new activity arrives
    useEffect(() => {
        feedBottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [activities.length]);

    // ─── Post Comment on an Activity ──────────────────────────────────────────
    const handlePostComment = async (activityId) => {
        if (!commentText.trim()) return;
        setPostingComment(true);
        try {
            const res = await fetch(`${API}/Activities/comments`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    activityId,
                    userId: currentUser.userId,
                    userName: currentUser.userName,
                    content: commentText.trim(),
                }),
            });
            if (res.ok) { setCommentText(""); fetchActivities(); }
        } catch (e) { console.error(e); }
        finally { setPostingComment(false); }
    };

    // ─── Post Reply to a Comment ───────────────────────────────────────────────
    const handlePostReply = async () => {
        if (!replyText.trim() || !replyingTo) return;
        setPostingReply(true);
        try {
            const res = await fetch(`${API}/Activities/comments`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    activityId: replyingTo.activityId,
                    parentCommentId: replyingTo.commentId,
                    userId: currentUser.userId,
                    userName: currentUser.userName,
                    content: replyText.trim(),
                }),
            });
            if (res.ok) { setReplyText(""); setReplyingTo(null); fetchActivities(); }
        } catch (e) { console.error(e); }
        finally { setPostingReply(false); }
    };

    // ─── React to Activity ────────────────────────────────────────────────────
    const handleActivityReaction = async (activityId, reactionType) => {
        const activity = activities.find((a) => a.activityId === activityId);
        const existing = activity?.reactionSummary?.userReaction;
        try {
            if (existing === reactionType) {
                await fetch(`${API}/Activities/${activityId}/reactions/${currentUser.userId}`, { method: "DELETE" });
            } else {
                await fetch(`${API}/Activities/${activityId}/reactions`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ userId: currentUser.userId, userName: currentUser.userName, reactionType }),
                });
            }
            fetchActivities();
        } catch (e) { console.error(e); }
    };

    // ─── React to Comment ─────────────────────────────────────────────────────
    const handleCommentReaction = async (commentId, reactionType) => {
        let existing = null;
        for (const act of activities) {
            const c = act.comments?.find((x) => x.commentId === commentId);
            if (c) { existing = c.reactionSummary?.userReaction; break; }
            for (const c2 of act.comments || []) {
                const r = c2.replies?.find((x) => x.commentId === commentId);
                if (r) { existing = r.reactionSummary?.userReaction; break; }
            }
        }
        try {
            if (existing === reactionType) {
                await fetch(`${API}/Activities/comments/${commentId}/reactions/${currentUser.userId}`, { method: "DELETE" });
            } else {
                await fetch(`${API}/Activities/comments/${commentId}/reactions`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ userId: currentUser.userId, userName: currentUser.userName, reactionType }),
                });
            }
            fetchActivities();
        } catch (e) { console.error(e); }
    };


    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ backgroundColor: "rgba(0,0,0,0.80)", backdropFilter: "blur(6px)" }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div
                className="w-full max-w-5xl max-h-[90vh] flex flex-col rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50"
                style={{ background: "#0f172a" }}
            >
                {/* ── Header ── */}
                <div
                    className="flex items-center justify-between px-6 py-4 shrink-0"
                    style={{ background: "linear-gradient(135deg, #1d4ed8 0%, #2563eb 60%, #3b82f6 100%)" }}
                >
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-white/20 flex items-center justify-center shrink-0">
                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                            </svg>
                        </div>
                        <div>
                            <h2 className="text-white font-bold text-lg leading-tight">{ticket.ticketNumber}</h2>
                            <p className="text-white/60 text-xs">{formatDate(ticket.createdAt)}</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusStyle(ticket.status)}`}>{ticket.status}</span>
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getPriorityStyle(ticket.priority)}`}>{ticket.priority}</span>
                        <button
                            onClick={onClose}
                            className="ml-2 w-8 h-8 rounded-full bg-white/10 hover:bg-white/25 flex items-center justify-center text-white transition-all"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="flex flex-1 overflow-hidden">

                    {/* LEFT: Ticket Details */}
                    <div
                        className="w-60 shrink-0 border-r border-slate-700/50 overflow-y-auto p-5 space-y-5"
                        style={{ backgroundColor: "#1e293b" }}
                    >
                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-3">Ticket Details</p>
                            <div className="space-y-3">
                                <SidebarItem label="Subject" value={ticket.subject} />
                                <div>
                                    <p className="text-xs text-slate-500 mb-0.5">Ticket ID</p>
                                    <p className="text-xs font-mono text-slate-300 break-all">{ticket.ticketNumber}</p>
                                </div>
                                <SidebarItem label="Category" value={ticket.category} />
                                <div>
                                    <p className="text-xs text-slate-500 mb-1">Priority</p>
                                    <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${getPriorityStyle(ticket.priority)}`}>{ticket.priority || "N/A"}</span>
                                </div>
                                <div>
                                    <p className="text-xs text-slate-500 mb-1">Status</p>
                                    <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${getStatusStyle(ticket.status)}`}>{ticket.status || "N/A"}</span>
                                </div>
                                <SidebarItem label="Submitted" value={formatDate(ticket.createdAt)} />
                            </div>
                        </div>

                        {ticket.attachment && (
                            <div>
                                <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-2">Attachment</p>
                                <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-700/40 border border-slate-600/40">
                                    <svg className="w-4 h-4 text-blue-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                    </svg>
                                    <span className="text-xs text-slate-300 truncate">{ticket.attachment}</span>
                                </div>
                            </div>
                        )}

                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-3">Submitted By</p>
                            <div className="flex items-center gap-2.5 p-3 rounded-xl bg-slate-700/40 border border-slate-600/40 mb-2">
                                <div className="w-9 h-9 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-bold shrink-0">
                                    {initials(ticket.name)}
                                </div>
                                <div className="min-w-0">
                                    <p className="text-sm font-semibold text-white truncate">{ticket.name || "—"}</p>
                                    <p className="text-xs text-slate-400 truncate">{ticket.email}</p>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                                <div className="p-2 rounded-lg bg-slate-700/30 border border-slate-600/30">
                                    <p className="text-xs text-slate-500 mb-0.5">Year Level</p>
                                    <p className="text-sm text-slate-300">{ticket.yearLevel || "—"}</p>
                                </div>
                                <div className="p-2 rounded-lg bg-slate-700/30 border border-slate-600/30">
                                    <p className="text-xs text-slate-500 mb-0.5">Section</p>
                                    <p className="text-sm text-slate-300">{ticket.section || "—"}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CENTER: Progress + Activity Feed */}
                    <div className="flex-1 flex flex-col overflow-hidden" style={{ backgroundColor: "#0f172a" }}>

                        {/* Progress Bar */}
                        <div className="px-6 py-4 border-b border-slate-700/40 shrink-0" style={{ backgroundColor: "#1e293b" }}>
                            <div className="flex items-center justify-between mb-2">
                                <p className="text-xs font-semibold text-slate-400 uppercase tracking-widest">Progress</p>
                                <p className="text-sm font-bold text-blue-400">{progressPct}%</p>
                            </div>
                            <div className="w-full bg-slate-700/60 rounded-full h-1.5 mb-4">
                                <div
                                    className="h-1.5 rounded-full transition-all duration-700"
                                    style={{ width: `${progressPct}%`, background: "linear-gradient(90deg, #3b82f6, #06b6d4)" }}
                                />
                            </div>
                            <div className="flex items-center">
                                {steps.map((step, i) => (
                                    <React.Fragment key={step}>
                                        <div className="flex items-center gap-2">
                                            <div className={`w-5 h-5 rounded-full flex items-center justify-center border-2 transition-all ${i <= stepIndex ? "bg-blue-500 border-blue-500" : "bg-transparent border-slate-600"}`}>
                                                {i <= stepIndex && (
                                                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                                    </svg>
                                                )}
                                            </div>
                                            <span className={`text-xs font-medium ${i <= stepIndex ? "text-blue-400" : "text-slate-500"}`}>{step}</span>
                                        </div>
                                        {i < steps.length - 1 && <div className={`flex-1 h-px mx-3 ${i < stepIndex ? "bg-blue-500" : "bg-slate-700"}`} />}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>

                        {/* Feed Scroll Area */}
                        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-4">
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-2">Activity Feed</p>

                            {loadingActivities && (
                                <div className="flex items-center gap-3 text-slate-500 text-sm py-8 justify-center">
                                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-500 border-t-transparent" />
                                    Loading activity...
                                </div>
                            )}

                            {!loadingActivities && activities.length === 0 && !ticket.description && (
                                <div className="text-center py-10">
                                    <div className="w-14 h-14 rounded-2xl bg-slate-700/40 flex items-center justify-center mx-auto mb-3">
                                        <svg className="w-7 h-7 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                        </svg>
                                    </div>
                                    <p className="text-slate-500 text-sm">No activity yet</p>
                                    <p className="text-slate-600 text-xs mt-1">Updates from support will appear here</p>
                                </div>
                            )}

                            {/* Activities with Comments & Reactions */}
                            {!loadingActivities && activities.map((activity) => (
                                <ActivityCard
                                    key={activity.activityId}
                                    activity={activity}
                                    currentUser={currentUser}
                                    currentUserPic={currentUserPic}
                                    onReact={(type) => handleActivityReaction(activity.activityId, type)}
                                    onCommentReact={handleCommentReaction}
                                    onPostComment={() => handlePostComment(activity.activityId)}
                                    commentText={commentText}
                                    setCommentText={setCommentText}
                                    postingComment={postingComment}
                                    replyingTo={replyingTo}
                                    setReplyingTo={setReplyingTo}
                                    replyText={replyText}
                                    setReplyText={setReplyText}
                                    onPostReply={handlePostReply}
                                    postingReply={postingReply}
                                    formatDate={formatDate}
                                    initials={initials}
                                    apiBase={API}
                                />
                            ))}

                            {/* Original Description Card */}
                            {!loadingActivities && ticket.description && (
                                <div className="rounded-xl border border-slate-700/30 p-4" style={{ backgroundColor: "#1a2235" }}>
                                    <div className="flex items-center gap-2 mb-2">
                                        <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <p className="text-xs text-slate-500 font-medium">Original Request</p>
                                    </div>
                                    <p className="text-sm text-slate-400 leading-relaxed">{ticket.description}</p>
                                </div>
                            )}

                            <div ref={feedBottomRef} />
                        </div>

                        {/* Read-only footer note (no input here; commenting is per-activity) */}
                        <div className="px-6 py-3 border-t border-slate-700/40 shrink-0">
                            <p className="text-xs text-slate-600 text-center">💬 React or comment on each activity above</p>
                        </div>
                    </div>

                    {/* RIGHT: Assigned + Stats */}
                    <div className="w-52 shrink-0 border-l border-slate-700/50 overflow-y-auto p-5 space-y-5" style={{ backgroundColor: "#1e293b" }}>
                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-3">Assigned To</p>
                            {ticket.assignees && ticket.assignees !== "" && ticket.assignees !== "Unassigned" ? (
                                <div className="flex items-center gap-2.5">
                                    <div className="w-9 h-9 rounded-full bg-indigo-500/80 flex items-center justify-center text-white text-xs font-bold shrink-0 overflow-hidden">
                                        {assigneePic
                                            ? <img src={assigneePic} className="w-full h-full object-cover" alt={ticket.assignees} />
                                            : initials(ticket.assignees)
                                        }
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-semibold text-white truncate">{ticket.assignees}</p>
                                        <p className="text-xs text-slate-500">Assignee</p>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex items-center gap-2.5">
                                    <div className="w-9 h-9 rounded-full bg-slate-600/50 border border-slate-600 flex items-center justify-center">
                                        <svg className="w-4 h-4 text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                        </svg>
                                    </div>
                                    <p className="text-sm text-slate-500 italic">Unassigned</p>
                                </div>
                            )}
                        </div>

                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-3">Quick Stats</p>
                            <div className="space-y-3">
                                <div className="flex items-center justify-between">
                                    <span className="text-xs text-slate-500">Days Open</span>
                                    <span className="text-xs font-semibold text-slate-300">
                                        {ticket.createdAt ? Math.floor((Date.now() - new Date(ticket.createdAt)) / 86400000) : "—"}
                                    </span>
                                </div>
                                <div className="w-full h-px bg-slate-700/50" />
                                <div className="flex items-center justify-between">
                                    <span className="text-xs text-slate-500">Priority</span>
                                    <span className={`text-xs font-semibold ${{ Low: "text-green-400", Medium: "text-yellow-400", High: "text-orange-400", Critical: "text-red-400" }[ticket.priority] || "text-slate-400"}`}>{ticket.priority || "—"}</span>
                                </div>
                                <div className="w-full h-px bg-slate-700/50" />
                                <div className="flex items-center justify-between">
                                    <span className="text-xs text-slate-500">Stage</span>
                                    <span className={`text-xs font-semibold ${ticket.status === "Resolved" || ticket.status === "Closed" ? "text-green-400" : ticket.status === "In Progress" ? "text-blue-400" : ticket.status === "Pending" ? "text-yellow-400" : "text-slate-400"}`}>{ticket.status || "—"}</span>
                                </div>
                                {ticket.team && (<>
                                    <div className="w-full h-px bg-slate-700/50" />
                                    <div className="flex items-center justify-between">
                                        <span className="text-xs text-slate-500">Team</span>
                                        <span className="text-xs font-semibold text-slate-300 text-right max-w-24 truncate">{ticket.team}</span>
                                    </div>
                                </>)}
                            </div>
                        </div>

                        <div>
                            <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-3">Labels</p>
                            <div className="flex flex-wrap gap-1.5">
                                {ticket.category && <span className="px-2 py-1 rounded-full text-xs bg-blue-500/15 text-blue-400 border border-blue-500/25">{ticket.category}</span>}
                                {ticket.priority && <span className={`px-2 py-1 rounded-full text-xs border ${{ Low: "bg-green-500/15 text-green-400 border-green-500/25", Medium: "bg-yellow-500/15 text-yellow-400 border-yellow-500/25", High: "bg-orange-500/15 text-orange-400 border-orange-500/25", Critical: "bg-red-500/15 text-red-400 border-red-500/25" }[ticket.priority] || "bg-slate-500/15 text-slate-400 border-slate-500/25"}`}>{ticket.priority}</span>}
                                {ticket.tags && ticket.tags !== "" && ticket.tags.split(",").map((tag, i) => (
                                    <span key={i} className="px-2 py-1 rounded-full text-xs bg-slate-600/30 text-slate-400 border border-slate-600/30">{tag.trim()}</span>
                                ))}
                            </div>
                        </div>

                        {ticket.assignmentRequest && ticket.assignmentRequest !== "" && (
                            <div>
                                <p className="text-xs font-semibold text-slate-500 uppercase tracking-widest mb-2">Assignment</p>
                                <div className={`px-3 py-2 rounded-xl text-xs border ${ticket.assignmentRequestApproved === true ? "bg-green-500/10 border-green-500/20 text-green-400" : ticket.assignmentRequestApproved === false ? "bg-red-500/10 border-red-500/20 text-red-400" : "bg-yellow-500/10 border-yellow-500/20 text-yellow-400"}`}>
                                    {ticket.assignmentRequestApproved === true ? "✓ Request Approved" : ticket.assignmentRequestApproved === false ? "✗ Request Rejected" : "⏳ Pending Approval"}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// ─── ActivityCard ──────────────────────────────────────────────────────────────
// Renders one activity post with: content, image, reactions, comments, replies
function ActivityCard({
    activity, currentUser, onReact, onCommentReact,
    onPostComment, commentText, setCommentText, postingComment,
    replyingTo, setReplyingTo, replyText, setReplyText, onPostReply, currentUserPic, postingReply,
    formatDate, initials, apiBase,
}) {
    const [showComments, setShowComments] = useState(true);
    const [showReactionPicker, setShowReactionPicker] = useState(false);
    const [showCommentBox, setShowCommentBox] = useState(false);
    const [activityUserPic, setActivityUserPic] = useState(null); // ← DAGDAG
    const pickerRef = useRef(null);

    // ← DAGDAG — fetch profile pic ng activity poster
  useEffect(() => {
    if (!activity.userId) return;
    fetch(`${apiBase}/Admin/get-profile-picture/${activity.userId}`)
        .then(r => r.ok ? r.blob() : null)
        .then(blob => { if (blob) setActivityUserPic(URL.createObjectURL(blob)); })
        .catch(() => { });
}, [activity.userId, apiBase]);

    // Close picker on outside click
    useEffect(() => {
        const handler = (e) => { if (pickerRef.current && !pickerRef.current.contains(e.target)) setShowReactionPicker(false); };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const myReaction = activity.reactionSummary?.userReaction;
    const totalReactions = activity.reactionSummary?.totalReactions || 0;
    const reactionCounts = activity.reactionSummary?.reactionCounts || {};

    return (
        <div className="rounded-xl border border-slate-700/50 overflow-hidden" style={{ backgroundColor: "#1e293b" }}>
            {/* Author Row */}
            <div className="flex items-center gap-3 px-4 pt-4 pb-2">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white text-xs font-bold shrink-0 overflow-hidden">
                    {activityUserPic
                        ? <img src={activityUserPic} alt={activity.userName} className="w-full h-full object-cover" />
                        : initials(activity.userName || "S")
                    }
                </div>
                <div>
                    <p className="text-sm font-semibold text-white leading-tight">{activity.userName || "Support"}</p>
                    <p className="text-xs text-slate-500">{formatDate ? formatDate(activity.createdAt) : activity.createdAt}</p>
                </div>
            </div>

            {/* Content */}
            {activity.content && activity.content.trim() && (
                <p className="px-4 pb-2 text-sm text-slate-200 leading-relaxed whitespace-pre-wrap">{activity.content}</p>
            )}

            {/* Image */}
            {activity.hasImage && (
                <div className="px-4 pb-3">
                    <img
                        src={`${apiBase}/Activities/${activity.activityId}/image`}
                        alt="Activity"
                        className="max-h-56 rounded-lg border border-slate-700 cursor-pointer hover:opacity-90 transition-opacity"
                        onClick={() => window.open(`${apiBase}/Activities/${activity.activityId}/image`, "_blank")}
                    />
                </div>
            )}

            {/* Reaction Summary */}
            {totalReactions > 0 && (
                <div className="px-4 pb-2 flex items-center gap-1.5">
                    <div className="flex -space-x-1">
                        {Object.entries(reactionCounts).map(([type, count]) =>
                            count > 0 ? (
                                <span key={type} className="text-xs" title={`${count} ${type}`}>
                                    {Object.entries(REACTIONS).find(([, v]) => v === type)?.[0]}
                                </span>
                            ) : null
                        )}
                    </div>
                    <span className="text-xs text-slate-400">{totalReactions}</span>
                </div>
            )}

            {/* Action Bar */}
            <div className="flex items-center gap-1 px-3 py-2 border-t border-slate-700/40">
                {/* React Button */}
                <div className="relative" ref={pickerRef}>
                    <button
                        onClick={() => setShowReactionPicker((p) => !p)}
                        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all hover:bg-slate-700/60 ${myReaction ? REACTION_COLORS[myReaction] : "text-slate-400 hover:text-slate-200"}`}
                    >
                        {myReaction
                            ? <>{Object.entries(REACTIONS).find(([, v]) => v === myReaction)?.[0]} {myReaction}</>
                            : <>👍 React</>}
                    </button>

                    {/* Emoji Picker */}
                    {showReactionPicker && (
                        <div className="absolute bottom-full left-0 mb-2 bg-slate-800 border border-slate-700 rounded-2xl shadow-2xl p-2 flex gap-1 z-20">
                            {Object.entries(REACTIONS).map(([emoji, type]) => (
                                <button
                                    key={type}
                                    onClick={() => { onReact(type); setShowReactionPicker(false); }}
                                    title={type}
                                    className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg transition-all hover:bg-slate-700 hover:scale-125 ${myReaction === type ? "bg-slate-700 ring-2 ring-blue-500" : ""}`}
                                >
                                    {emoji}
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                {/* Comment Toggle */}
                <button
                    onClick={() => { setShowCommentBox((p) => !p); setShowComments(true); }}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium text-slate-400 hover:text-slate-200 hover:bg-slate-700/60 transition-all"
                >
                    💬 {activity.commentCount > 0 ? `${activity.commentCount} Comment${activity.commentCount > 1 ? "s" : ""}` : "Comment"}
                </button>
            </div>

            {/* Comment Input Box */}
            {showCommentBox && (
                <div className="px-4 pb-3 border-t border-slate-700/30" style={{ backgroundColor: "#162032" }}>
                    <div className="flex items-start gap-2 pt-3">
                        <div className="w-7 h-7 rounded-full bg-blue-500 flex items-center justify-center text-white text-xs font-bold shrink-0 mt-0.5 overflow-hidden">
                            {currentUserPic
                                ? <img src={currentUserPic} alt="me" className="w-full h-full object-cover" />
                                : currentUser.userName.charAt(0).toUpperCase()
                            }
                        </div>
                        <div className="flex-1">
                            <textarea
                                value={commentText}
                                onChange={(e) => setCommentText(e.target.value)}
                                onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onPostComment(); } }}
                                placeholder="Write a comment..."
                                rows={2}
                                className="w-full bg-slate-800/80 border border-slate-700 rounded-xl px-3 py-2 text-xs text-white placeholder-slate-500 focus:outline-none focus:ring-1 focus:ring-blue-500/60 resize-none transition-all"
                            />
                            <div className="flex justify-end gap-2 mt-1.5">
                                <button
                                    onClick={() => { setShowCommentBox(false); setCommentText(""); }}
                                    className="px-3 py-1 text-xs text-slate-400 hover:text-white rounded-lg transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={onPostComment}
                                    disabled={!commentText.trim() || postingComment}
                                    className="px-4 py-1 bg-blue-500 hover:bg-blue-600 disabled:bg-slate-700 disabled:opacity-50 text-white text-xs font-semibold rounded-lg transition-all flex items-center gap-1.5"
                                >
                                    {postingComment ? (
                                        <><div className="w-3 h-3 border-2 border-white/40 border-t-white rounded-full animate-spin" /> Posting...</>
                                    ) : "Post"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Comments List */}
            {showComments && activity.comments?.length > 0 && (
                <div className="px-4 pb-3 space-y-2 border-t border-slate-700/30" style={{ backgroundColor: "#162032" }}>
                    {activity.comments.map((comment) => (
                        <CommentItem
                            key={comment.commentId}
                            comment={comment}
                            activityId={activity.activityId}
                            currentUser={currentUser}
                            onReact={onCommentReact}
                            replyingTo={replyingTo}
                            setReplyingTo={setReplyingTo}
                            replyText={replyText}
                            setReplyText={setReplyText}
                            onPostReply={onPostReply}
                            postingReply={postingReply}
                            formatDate={formatDate}
                            initials={initials}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

// ─── CommentItem ───────────────────────────────────────────────────────────────
function CommentItem({ comment, activityId, currentUser, onReact, replyingTo, setReplyingTo, replyText, setReplyText, onPostReply, postingReply, formatDate, initials }) {
    const [showPicker, setShowPicker] = useState(false);
    const pickerRef = useRef(null);
    const myReaction = comment.reactionSummary?.userReaction;
    const isReplying = replyingTo?.commentId === comment.commentId;

    useEffect(() => {
        const h = (e) => { if (pickerRef.current && !pickerRef.current.contains(e.target)) setShowPicker(false); };
        document.addEventListener("mousedown", h);
        return () => document.removeEventListener("mousedown", h);
    }, []);

    return (
        <div className="mt-2">
            <div className="flex items-start gap-2">
                <div className="w-6 h-6 rounded-full bg-gradient-to-br from-blue-400 to-pink-400 flex items-center justify-center text-white text-xs font-bold shrink-0 mt-0.5">
                    {initials(comment.userName)}
                </div>
                <div className="flex-1 min-w-0">
                    <div className="bg-slate-800/60 rounded-xl px-3 py-2 border border-slate-700/40">
                        <p className="text-xs font-semibold text-white mb-0.5">{comment.userName}</p>
                        <p className="text-xs text-slate-300 leading-relaxed">{comment.content}</p>
                    </div>

                    {/* Comment Actions */}
                    <div className="flex items-center gap-3 mt-1 ml-1">
                        <span className="text-xs text-slate-600">{formatDate ? formatDate(comment.createdAt) : ""}</span>

                        {/* Reaction */}
                        <div className="relative" ref={pickerRef}>
                            <button
                                onClick={() => setShowPicker((p) => !p)}
                                className={`text-xs transition-colors ${myReaction ? REACTION_COLORS[myReaction] : "text-slate-500 hover:text-slate-300"}`}
                            >
                                {myReaction ? `${Object.entries(REACTIONS).find(([, v]) => v === myReaction)?.[0]} ${myReaction}` : "React"}
                            </button>
                            {showPicker && (
                                <div className="absolute bottom-full left-0 mb-1 bg-slate-800 border border-slate-700 rounded-xl shadow-xl p-1.5 flex gap-1 z-20">
                                    {Object.entries(REACTIONS).map(([emoji, type]) => (
                                        <button
                                            key={type}
                                            onClick={() => { onReact(comment.commentId, type); setShowPicker(false); }}
                                            className={`w-8 h-8 rounded-lg flex items-center justify-center text-base transition-all hover:bg-slate-700 hover:scale-125 ${myReaction === type ? "bg-slate-700 ring-2 ring-blue-500" : ""}`}
                                            title={type}
                                        >
                                            {emoji}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Reply */}
                        <button
                            onClick={() => setReplyingTo(isReplying ? null : { activityId, commentId: comment.commentId, userName: comment.userName })}
                            className="text-xs text-slate-500 hover:text-blue-400 transition-colors"
                        >
                            {isReplying ? "Cancel" : "Reply"}
                        </button>

                        {/* Reaction count */}
                        {comment.reactionSummary?.totalReactions > 0 && (
                            <span className="text-xs text-slate-500">{comment.reactionSummary.totalReactions} reaction{comment.reactionSummary.totalReactions > 1 ? "s" : ""}</span>
                        )}
                    </div>

                    {/* Reply Input */}
                    {isReplying && (
                        <div className="mt-2 ml-2 flex items-start gap-2">
                            <div className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center text-white text-xs font-bold shrink-0 mt-0.5">
                                {currentUser.userName.charAt(0).toUpperCase()}
                            </div>
                            <div className="flex-1">
                                <textarea
                                    value={replyText}
                                    onChange={(e) => setReplyText(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onPostReply(); } }}
                                    placeholder={`Reply to ${replyingTo.userName}...`}
                                    rows={2}
                                    className="w-full bg-slate-800 border border-slate-700 rounded-xl px-3 py-1.5 text-xs text-white placeholder-slate-500 focus:outline-none focus:ring-1 focus:ring-blue-500/60 resize-none"
                                />
                                <div className="flex justify-end gap-2 mt-1">
                                    <button onClick={() => { setReplyingTo(null); setReplyText(""); }} className="text-xs text-slate-400 hover:text-white px-2 py-0.5 rounded transition-colors">Cancel</button>
                                    <button
                                        onClick={onPostReply}
                                        disabled={!replyText.trim() || postingReply}
                                        className="px-3 py-0.5 bg-blue-500 hover:bg-blue-600 disabled:bg-slate-700 disabled:opacity-50 text-white text-xs font-semibold rounded-lg transition-all"
                                    >
                                        {postingReply ? "..." : "Reply"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Replies */}
                    {comment.replies?.length > 0 && (
                        <div className="mt-2 ml-3 space-y-2 border-l-2 border-slate-700/40 pl-3">
                            {comment.replies.map((reply) => (
                                <div key={reply.commentId} className="flex items-start gap-2">
                                    <div className="w-5 h-5 rounded-full bg-gradient-to-br from-green-400 to-blue-400 flex items-center justify-center text-white text-xs font-bold shrink-0 mt-0.5">
                                        {initials(reply.userName)}
                                    </div>
                                    <div className="flex-1">
                                        <div className="bg-slate-800/40 rounded-xl px-3 py-1.5 border border-slate-700/30">
                                            <p className="text-xs font-semibold text-white mb-0.5">{reply.userName}</p>
                                            <p className="text-xs text-slate-300">{reply.content}</p>
                                        </div>
                                        {reply.reactionSummary?.totalReactions > 0 && (
                                            <span className="text-xs text-slate-600 ml-1">{reply.reactionSummary.totalReactions} reaction{reply.reactionSummary.totalReactions > 1 ? "s" : ""}</span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

// ─── SidebarItem ───────────────────────────────────────────────────────────────
const SidebarItem = ({ label, value }) => (
    <div>
        <p className="text-xs text-slate-500 mb-0.5">{label}</p>
        <p className="text-sm font-medium text-slate-200">{value || "N/A"}</p>
    </div>
);



// Profile View Component
const ProfileView = ({ userData, profilePicture, loadProfilePicture, setCurrentView, isDarkMode }) => {
    const [uploading, setUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);

    // ===== ADDITION FOR CHANGE PASSWORD =====
    const [activeTab, setActiveTab] = useState("profile"); // "profile" | "changePassword"
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordMessage, setPasswordMessage] = useState("");
    const [passwordLoading, setPasswordLoading] = useState(false);

    const handleChangePassword = async () => {
        if (!newPassword || !confirmPassword) {
            setPasswordMessage("Please fill out both fields.");
            return;
        }
        if (newPassword !== confirmPassword) {
            setPasswordMessage("Passwords do not match.");
            return;
        }

        setPasswordLoading(true);
        setPasswordMessage("");

        try {
            const response = await fetch(
                `http://localhost:2024/api/Users/update-password/${userData.username}`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ newPassword, confirmPassword }),
                }
            );

            if (response.ok) {
                setPasswordMessage("Password updated successfully!");
                setNewPassword("");
                setConfirmPassword("");
            } else {
                const data = await response.json();
                setPasswordMessage(data.message || "Failed to update password.");
            }
        } catch (err) {
            console.error(err);
            setPasswordMessage("Error updating password.");
        } finally {
            setPasswordLoading(false);
        }
    };
    // ===== END ADDITION =====

    const handleProfilePictureUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setUploading(true);
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await fetch(
                `${config.API_BASE_URL}/Users/upload-profile-picture?username=${userData.username}`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (response.ok) {
                setUploadSuccess(true);
                setTimeout(() => setUploadSuccess(false), 3000);
                loadProfilePicture(userData.username);
            }
        } catch (error) {
            console.error("Error uploading profile picture:", error);
            alert("Failed to upload profile picture");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto">
            <button
                onClick={() => setCurrentView("dashboard")}
                className={`mb-6 flex items-center gap-2 ${isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition`}
            >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Back to Dashboard
            </button>

            {/* ===== ADD TAB BUTTONS ===== */}
            <div className="flex gap-4 mb-6">
                <button
                    className={`p-3 rounded-md ${activeTab === "profile" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"} transition`}
                    onClick={() => setActiveTab("profile")}
                >
                    Profile Info
                </button>
                <button
                    className={`p-3 rounded-md ${activeTab === "changePassword" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700"} transition`}
                    onClick={() => setActiveTab("changePassword")}
                >
                    Change Password
                </button>
            </div>

            {/* ===== ACTIVE TAB CONTENT ===== */}
            {activeTab === "profile" && (
                <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-2xl p-8 shadow-sm transition-colors duration-300`}>
                    <h2 className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-8`}>My Profile</h2>

                    {/* Profile Picture Section */}
                    <div className={`flex flex-col items-center mb-8 pb-8 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                        <div className="relative group">
                            {profilePicture ? (
                                <img
                                    src={profilePicture}
                                    alt="Profile"
                                    className="w-32 h-32 rounded-full object-cover border-4 border-blue-500"
                                />
                            ) : (
                                <div className="w-32 h-32 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center text-white font-bold text-5xl border-4 border-blue-500">
                                    {userData.fullNames.charAt(0).toUpperCase()}
                                </div>
                            )}
                            <label
                                htmlFor="profile-upload"
                                className="absolute bottom-0 right-0 bg-blue-500 hover:bg-blue-600 p-3 rounded-full cursor-pointer transition transform hover:scale-110 shadow-lg"
                            >
                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </label>
                            <input
                                id="profile-upload"
                                type="file"
                                accept="image/*"
                                onChange={handleProfilePictureUpload}
                                className="hidden"
                            />
                        </div>
                        <h3 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'} mt-4`}>{userData.fullNames}</h3>
                        <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{userData.email}</p>

                        {uploading && (
                            <div className="mt-4 flex items-center gap-2 text-blue-500">
                                <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-500 border-t-transparent"></div>
                                Uploading...
                            </div>
                        )}

                        {uploadSuccess && (
                            <div className="mt-4 bg-green-50 border border-green-500 text-green-700 px-4 py-2 rounded-lg">
                                Profile picture updated successfully!
                            </div>
                        )}
                    </div>

                    {/* Profile Information */}
                    <div className="grid md:grid-cols-2 gap-6">
                        <InfoItem label="Full Name" value={userData.fullNames} isDarkMode={isDarkMode} />
                        <InfoItem label="Email" value={userData.email} isDarkMode={isDarkMode} />
                        <InfoItem label="Username" value={userData.username} isDarkMode={isDarkMode} />
                        <InfoItem label="Phone" value={userData.phone || "Not provided"} isDarkMode={isDarkMode} />
                        <InfoItem label="Address" value={userData.address || "Not provided"} isDarkMode={isDarkMode} />
                        <InfoItem label="Language" value={userData.language === "en" ? "English" : userData.language} isDarkMode={isDarkMode} />
                        <InfoItem
                            label="Registration Date"
                            value={new Date(userData.registrationDate).toLocaleDateString()}
                            isDarkMode={isDarkMode}
                        />
                        <InfoItem label="User ID" value={userData.identificationCode} isDarkMode={isDarkMode} />
                    </div>
                </div>
            )}

            {activeTab === "changePassword" && (
                <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-2xl p-8 shadow-sm transition-colors duration-300`}>
                    <h2 className={`text-2xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Change Password</h2>

                    <div className="flex flex-col gap-4 max-w-md">
                        <input
                            type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="p-3 border rounded-md w-full"
                        />
                        <input
                            type="password"
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="p-3 border rounded-md w-full"
                        />
                        <button
                            onClick={handleChangePassword}
                            disabled={passwordLoading}
                            className="bg-blue-500 text-white p-3 rounded-md hover:bg-blue-600 transition disabled:opacity-50"
                        >
                            {passwordLoading ? "Updating..." : "Update Password"}
                        </button>
                        {passwordMessage && (
                            <div className={`${passwordMessage.includes("success") ? "text-green-600" : "text-red-600"}`}>
                                {passwordMessage}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

// Settings View Component
const SettingsView = ({ userData, setCurrentView, isDarkMode }) => (
    <div className="max-w-4xl mx-auto">
        <button
            onClick={() => setCurrentView("dashboard")}
            className={`mb-6 flex items-center gap-2 ${isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition`}
        >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Dashboard
        </button>

        <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-2xl p-8 shadow-sm transition-colors duration-300`}>
            <h2 className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-8`}>Settings</h2>

            <div className="space-y-6">
                <div className={`p-6 ${isDarkMode ? 'bg-gray-700/50 border-gray-600' : 'bg-gray-50 border-gray-200'} rounded-xl border`}>
                    <h3 className={`text-xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-2`}>Notifications</h3>
                    <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>Manage your notification preferences</p>
                    <label className="flex items-center gap-3 cursor-pointer">
                        <input type="checkbox" className="w-5 h-5 rounded text-blue-500" defaultChecked />
                        <span className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Email notifications</span>
                    </label>
                </div>

                <div className={`p-6 ${isDarkMode ? 'bg-gray-700/50 border-gray-600' : 'bg-gray-50 border-gray-200'} rounded-xl border`}>
                    <h3 className={`text-xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-2`}>Language</h3>
                    <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>Choose your preferred language</p>
                    <select className={`w-full px-4 py-2 ${isDarkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300 text-gray-900'} border rounded-lg`}>
                        <option value="en">English</option>
                        <option value="es">Spanish</option>
                        <option value="fr">French</option>
                    </select>
                </div>

                <div className={`p-6 ${isDarkMode ? 'bg-gray-700/50 border-gray-600' : 'bg-gray-50 border-gray-200'} rounded-xl border`}>
                    <h3 className={`text-xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-2`}>Change Password</h3>
                    <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>Update your account password</p>
                    <button className="px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-semibold transition">
                        Change Password
                    </button>
                </div>
            </div>
        </div>
    </div>
);

const QuickActionCard = ({ onClick, icon, title, description, isDarkMode }) => {
    return (
        <button
            onClick={onClick}
            className={`${isDarkMode ? 'bg-gray-800 border-gray-700 hover:border-blue-500' : 'bg-white border-gray-200 hover:border-blue-400'} border-2 rounded-2xl p-6 transition-all duration-300 transform hover:scale-105 shadow-sm hover:shadow-lg`}
        >
            <div className={`mb-4 ${isDarkMode ? 'text-blue-400' : 'text-blue-500'}`}>{icon}</div>
            <h3 className={`text-xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{title}</h3>
            <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{description}</p>
        </button>
    );
};
const InfoItem = ({ label, value, isDarkMode }) => (
    <div>
        <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mb-1 font-medium`}>{label}</p>
        <p className={`${isDarkMode ? 'text-gray-200' : 'text-gray-900'} font-semibold`}>{value}</p>
    </div>
);

export default UserDashboard;